import {
	Component,
	inject,
	Inject
} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

import {CoreModule} from "../../_core/core.module";
import { AppService } from '../../app.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';

import {MatButton} from "@angular/material/button";
import {MatDialog} from "@angular/material/dialog";
import * as _ from "lodash";
import {OfferComponent} from "../../order-items/offer/offer.component";

@Component({
	selector: 'app-chat-summary-bottom-sheet',
	templateUrl: './chat-summary-bottom-sheet.component.html',
	styleUrl: './chat-summary-bottom-sheet.component.scss',
	standalone: true,
	imports: [CommonModule, FormsModule, MatButton, CoreModule, MatIcon],
})
export class ChatSummaryBottomSheetComponent {
	// Services
	private readonly sheetRef = inject(MatBottomSheetRef<ChatSummaryBottomSheetComponent>);
	private readonly orderService = inject(OrderService);
	private readonly orderUtils = inject(OrderItemsUtilsService);
	public readonly appService = inject(AppService);
	grandTotal: number = 0;
	highlightValidationIssues: boolean = false;

	// Component state
	public basket: any[] = [];

	constructor(
		@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
		public dialog: MatDialog,
	) {
		console.log(data);
		this.basket = this.data.validItems.map(o => {
			let basketOffer = o.basketOffer;
			basketOffer.hasValidationIssues = o.hasValidationIssues;
			return basketOffer;
		});
		if (this.data.message) this.appService.alert({content: this.data.message});
		this.calculateBasketTotal();
	}

	calculateBasketTotal() {
		let total = 0, q = 0;
		this.basket.forEach(offer => {
			if (!offer.quantity) offer.quantity = 1;
			q += offer.quantity;
			total += (offer.total * offer.quantity);
		});
		this.grandTotal = total;
	}

	cancel() {
		this.sheetRef.dismiss();
	}

	addItems() {
		if (this.basket.find(o => o.hasValidationIssues)){
			this.highlightValidationIssues = true;
			setTimeout(() => {this.highlightValidationIssues = false}, 500);
			return;
		}
		this.basket.forEach(o => {
			this.orderService.addToBasket(o);
		});
		this.sheetRef.dismiss(true);
	}

	// ---------------------------------------------------------------->

	editOffer(offer) {
		this.openOfferDialog(offer, true).then((result: any) => {
			if (result) {
				if (result.mode === 'delete') {
					this.deleteOfferCont(offer);
				}else {
					const index = this.basket.indexOf(offer);
					let response = result["viewItem"];
					delete response.hasValidationIssues;
					this.basket[index] = response;
					this.calculateBasketTotal();
				}
			}
		});
	}

	deleteOffer(offer, deleteAll?) {
		if (offer.quantity > 1) {
			--offer.quantity;
			this.calculateBasketTotal();
		} else {
			this.deleteOfferCont(offer);
		}
	}
	deleteOfferCont(offer) {
		let index = this.basket.indexOf(offer);
		this.basket.splice(index, 1);
		this.calculateBasketTotal();
		if (!this.basket.length) this.cancel();
	}

	duplicateOffer(offer) {
		this.orderService.validateOrderLimit(1, offer.total).then(() => {
			if (offer._reserved) {
				let newOffer = _.cloneDeep(offer);
				delete newOffer._reserved;
				newOffer._bid = this.orderUtils.getObjectId();
				newOffer.quantity = 1;
				this.basket.push(newOffer);
			} else {
				++offer.quantity;
			}
			this.calculateBasketTotal()
		});
	}

	openOfferDialog(_offer, isEdit = false) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(OfferComponent, {
				panelClass: ['to-offer-dialog', 'animated', 'fast', 'slideInLeft'],
				backdropClass: 'kiosk-fullscreen-backdrop',
				direction: this.appService.direction,
				//disableClose: true,
				closeOnNavigation: true,
				data: {
					offer: _offer,
					isEdit: isEdit,
					minWidth: 280
				},
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result) {
					resolve(result);
				}
			});
		});
	}


}
